import { render } from "./ModificaDatiAnagrafici.vue?vue&type=template&id=2c858058"
import script from "./ModificaDatiAnagrafici.vue?vue&type=script&lang=js"
export * from "./ModificaDatiAnagrafici.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__